import React from "react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// You can log to your backend
		function serializeError(error) {
			if (error instanceof Error) {
				return {
					message: error.message,
					stack: error.stack,
					name: error.name,
				};
			}
			// For non-Error objects (like rejected promises)
			return {
				message: typeof error === "string" ? error : JSON.stringify(error),
			};
		}

		const payload = JSON.stringify({
			"error": serializeError(error),
			"info": info.componentStack,
			"time": new Date().toISOString(),
		});

		this.getDerivedStateFromError(error);

		try {
			fetch("/api/index.php/log_error", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: payload,
			});
		} catch (e){

		}

		// Also update local state for fallback UI
		this.setState({ errorInfo: info });
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{padding: "3rem"}}>
					<h2>Something went wrong 😬</h2>
					<span style={{ padding: "2rem", color: "#cc0000" }}>
						<p>The system has caught this error and notified the tech team. It will
							be addressed in due time.
						</p>
						<h4 style={{color: "black"}}>You can also help accelerate the development process</h4>
						<ol>
							<li>Right click on the webpage to bring up a context menu</li>
							<li>From the dropdown options, select "Inspect Element" or something that looks similar</li>
							<li>From the tabs available in the right sidebar, select console</li>
							<li>Take a screenshot of the console log (particularly anything in red)</li>
							<li>Share this screenshot with the tech team</li>
						</ol>
					</span>
					<details style={{ whiteSpace: "pre-wrap" }}>
						{this.state.errorInfo?.componentStack ?? "no stacktrace caught"}
					</details>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
